import { useEffect } from 'react';
import { PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { B2B_WHOLESALE } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useAppDispatch } from 'App/store';
import {
  cleanWholesaleDetails,
  getOrderWholesaleDetails,
} from '../../ordersSlice/orderSlice';
import {
  getOrderWholesaleDetailsData,
  getOrderWholesaleDetailsStatus,
} from '../../ordersSlice/ordersSelectors/ordersSelectors';

interface InterfaceOrderWholesaleDetails {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isWholesale: boolean;
}

function useOrderWholesaleDetails(id: string): InterfaceOrderWholesaleDetails {
  const dispatch = useAppDispatch();

  const [hasAccountWholesaleTag] = useHasTags(B2B_WHOLESALE);

  const { isError, isLoading, isSuccess } = useSelector(
    getOrderWholesaleDetailsStatus,
  );
  const { isWholesale } = useSelector(getOrderWholesaleDetailsData);

  useEffect(() => {
    let promise: Promise<PayloadAction<unknown>> | null = null;
    if (hasAccountWholesaleTag) {
      promise = dispatch(getOrderWholesaleDetails(id));
    }
    return () => {
      if (promise !== null) {
        dispatch(cleanWholesaleDetails());
      }
    };
  }, [dispatch, id, hasAccountWholesaleTag]);

  return {
    isError,
    isLoading,
    isSuccess,
    isWholesale,
  };
}

export default useOrderWholesaleDetails;
